export default __webpack_public_path__ + "static/media/noback.8049eb3e.svg";